module.exports = __webpack_public_path__ + "static/img/80_cheese.697530d7.jpg";